import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Card } from "antd";

const Settings = () => {
  return (
    <div className="screen-box">
      <div className="main-box">
        <div className="main-txt">Settings</div>
      </div>
    </div>
  );
};

export default Settings;
